import { Row } from '@tanstack/react-table';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { MoreHorizontal } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Label as TLabel, LabelGroup } from '../types';
import { DeleteButton } from '@/components/delete-button';
import { Separator } from '@/components/ui/separator';
import { useDeleteLabel } from '../api/delete-label';
import { Label } from './label';

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function LabelTableRowActions<TData>({ row }: DataTableRowActionsProps<TData & TLabel>) {
  const { mutateAsync: deleteLabel } = useDeleteLabel({});

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="flex h-8 w-8 p-0 data-[state=open]:bg-muted">
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[160px]">
        <Link to={`/labels/edit/${row.original?.labelId}`}>
          <DropdownMenuItem>
            <Label name="edit_label_table_action_text" groupName={LabelGroup.ADMIN_LABEL} />
          </DropdownMenuItem>
        </Link>
        <Separator />
        <DeleteButton
          TitleComponent="delete_user_title"
          DescriptionComponent={
            <Label name="delete_label_table_action_description" groupName={LabelGroup.ADMIN_LABEL} />
          }
          ButtonComponent={
            <div className="text-destructive flex items-center text-sm px-2 py-1.5">
              <Label name="delete_label_table_action_text" groupName={LabelGroup.ADMIN_LABEL} />
            </div>
          }
          onDelete={() => deleteLabel({ labelId: row.original?.labelId })}
        />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
